import React, { useState, useMemo, useEffect } from 'react'
import { Detail } from '@tecuity/granite-ui/Detail'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import CaretUpIcon from '@tecuity/sos-icons/react/caret-up'
import PencileIcon from '@tecuity/sos-icons/react/pencil-solid'
import './ReceiptValidation.scss'
import format from 'date-fns/format'
// import { detailCardCss } from '../../RecordDetailsPage/RecordDetailsPage'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'
import { useGetDLNLink } from '../../../Utilities/Utilities'

export const detailEnterDetailCardCss = {
  backgroundColor: 'white',
  h3: {
    backgroundColor: '#757575',
  },
}

export const detailErrorCardCss = {
  backgroundColor: 'white',
  h3: {
    backgroundColor: `hsl(345deg 100% 42%)`,
  },
}

const ReceiptPayment = ({
  paymentItem,
  updateItem,
  paymentIndex,
  isEditable,
  failedValidation,
  deleteItem,
}) => {
  const [expanded, setExpanded] = useState(false)
  const [item, setItem] = useState(paymentItem)

  useEffect(() => {
    setItem(paymentItem)
  }, [paymentItem])

  const userCanEdit = useMemo(() => {
    return (
      isEditable &&
      !(
        paymentItem.BatchResponse &&
        (paymentItem.BatchResponse.PostDate || paymentItem.BatchResponse.PostNum)
      )
    )
  }, [isEditable])

  const toggleEdit = () => {
    if (updateItem) updateItem(item, paymentIndex)

    // setExpanded(true);
  }

  const payor = useMemo(() => {
    if (item.Payor) return item.Payor
    return {}
  }, [item])

  const batch = useMemo(() => {
    if (item.BatchResponse) return item.BatchResponse
    return {}
  }, [item])

  const formattedAmount = useMemo(() => {
    if (item.Amount && Number(item.Amount) < 0) {
      return `($${(Number(item.Amount) * -1)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')})`
    } else {
      return `$${(Number(item.Amount) || 0)
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    }
  }, [item])

  const amountClassName = useMemo(() => {
    if (item.Amount && Number(item.Amount) < 0) return 'charge-value'
    else return 'payment-value'
  }, [item])

  const dlnLink = useGetDLNLink(item.DLNNum, 'dln-label-override')

  if (!item.Type || !(item.Amount || item.Amount === 0)) {
    return (
      <DetailCard
        onClick={toggleEdit}
        label={
          <div
            style={{
              display: 'flex',
              gap: '10px',
              flexDirection: 'row',
              alignItems: 'center',
              color: 'white',
            }}
          >
            <p>DLN #:</p>
            {dlnLink}
          </div>
        }
        className="detailsCard"
      >
        <div className={true ? 'floating-card-variable-width lock-card' : ''}>
          <div className="floating-card-header">Click to Enter Payment Information</div>
        </div>
      </DetailCard>
    )
  }

  return (
    <DetailCard
      label={
        <div
          style={{
            display: 'flex',
            gap: '10px',
            flexDirection: 'row',
            alignItems: 'center',
            color: 'white',
          }}
        >
          <p>DLN #:</p>
          {dlnLink}
        </div>
      }
      className="detailsCard"
    >
      {/* // <div className="floating-card-variable-width charge-card"> */}
      <div className={true ? 'floating-card-variable-width lock-card' : ''}>
        <div className="floating-card-header">
          <Detail
            label="Payment Type"
            children={item.Type ? item.Type.Description : ''}
            fontSize="small"
          />
          <Detail label="Ref/Check #" children={item.RefCheckNum} fontSize="small" />

          <div className="floating-card-header currency">
            <Detail
              label="Amount"
              children={formattedAmount}
              fontSize="small"
              className={amountClassName}
            />
            {userCanEdit ? (
              <span title={'Delete Payment'}>
                <IconButton
                  onClick={() => {
                    deleteItem(item, paymentIndex, 'Payment')
                  }}
                  icon={<CrossHeavy />}
                  label="Delete Payment"
                  customCss={'padding: 5px !important; margin-left: 4px;'}
                />
              </span>
            ) : null}
            {userCanEdit ? (
              <span title={'Edit Payment Details'}>
                <IconButton
                  onClick={toggleEdit}
                  icon={<PencileIcon />}
                  label="Edit Payment Details"
                  customCss={'padding: 5px !important; margin-left: 4px;'}
                />
              </span>
            ) : null}
            <span title={`${expanded ? 'Hide' : 'View'} Payment Details`}>
              <IconButton
                onClick={() => {
                  setExpanded(!expanded)
                }}
                icon={expanded ? <CaretUpIcon /> : <CaretDownIcon />}
                label="View Payment Details"
                customCss={'padding: 5px !important; margin-left: 4px;'}
              />
            </span>
          </div>
        </div>
        <div className="floating-card-body">
          <div className="card-details">
            {expanded && (
              <React.Fragment>
                <div className="row card-row">
                  <DetailPayor
                    label={'Payor'}
                    name={payor.Name}
                    address={payor.Address}
                    address2={payor.Address2}
                    city={payor.City}
                    state={payor.State}
                    zip={payor.Zip}
                  />
                </div>
                <div className="row card-row">
                  <div className="num-and-date">
                    <Detail label="Batch #" children={batch.BatchNum} fontSize="small" />
                    <Detail
                      label="Batch Date"
                      children={
                        batch.CreatedAt ? format(new Date(batch.CreatedAt), 'MM/dd/yyyy') : null
                      }
                      fontSize="small"
                    />
                  </div>
                  <Detail label="Processed By" children={item.ProcessedBy} fontSize="small" />
                </div>
                <div className="row card-row">
                  <div className="num-and-date">
                    <Detail label="Post #" children={batch.PostNum} fontSize="small" />
                    <Detail
                      label="Post Date"
                      children={
                        batch.PostDate ? format(new Date(batch.PostDate), 'MM/dd/yyyy') : null
                      }
                      fontSize="small"
                    />
                  </div>
                  <div />
                </div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
      {/* // </div> */}
    </DetailCard>
  )
}

export default ReceiptPayment

const DetailPayor = ({
  label,
  name = '',
  address = '',
  address2 = '',
  city = '',
  state = '',
  zip = '',
}) => {
  return (
    <div className="payor-container">
      <dt className="payor-label">{label}</dt>
      <dd className="payor-details">
        <p>{name}</p>
        <p>{address}</p>
        {address2 && <p>{address2}</p>}
        <p>
          {city} {state}
          {state && zip ? ',' : ''} {zip}
        </p>
      </dd>
    </div>
  )
}
